<div
    class="feedback-overlay fixed inset-0 z-50 flex items-center justify-center p-4 max-sm:items-start max-sm:overflow-y-auto max-sm:p-3"
    (click)="uiStore.toggleFeedbackFormVisibility()"
    >

    @if (this.submitStatus() === this.submitStatusEnum.NOT_SUBMITTED || this.submitStatus() === this.submitStatusEnum.SUBMITTING) {
        <form
            [formGroup]="feedbackForm"
            (click)="$event.stopPropagation()"
            (ngSubmit)="onSubmit()"
            class="feedback-dialog relative w-full max-w-2xl overflow-hidden"
        >
            <!-- Loading State  -->
            @if (this.submitStatus() === this.submitStatusEnum.SUBMITTING) {

                <div
                    class="feedback-loading absolute inset-0 z-10 flex flex-col items-center justify-center gap-4"
                >

                    <div
                        class="h-10 w-10 animate-spin rounded-full
                            border-4 border-[#d6e3e4] border-t-[#007f8c]"
                    ></div>

                    <p class="feedback-loading-text text-sm font-medium">
                        {{ 'FEEDBACK.SUBMIT' | translate }}
                    </p>

                </div>

            }

            <div class="feedback-content min-w-0 px-8 pb-6 pt-7 max-sm:px-5 max-sm:pb-5 max-sm:pt-5">
                <div class="feedback-topline flex items-start justify-between mb-5">
                    <div>
                        <h2 class="mb-1">{{ 'FEEDBACK.TITLE' | translate }}</h2>
                        <p>{{ 'FEEDBACK.SUB_TITLE' | translate }}</p>
                    </div>
                    <button
                        type="button"
                        class="feedback-close -mr-1 -mt-1 grid h-8 w-8 place-items-center"
                        aria-label="Close feedback form"
                        title="Close"
                        [disabled]="this.submitStatus() === this.submitStatusEnum.SUBMITTING"
                        (click)="uiStore.toggleFeedbackFormVisibility()"
                    >
                        <span aria-hidden="true">×</span>
                    </button>
                </div>

                <div class="feedback-field mb-[1.15rem]">
                    <label class="mb-2 block">
                    {{ 'FEEDBACK.TYPE' | translate }}
                    </label>

                <select
                    formControlName="type"
                    class="feedback-control w-full px-3 py-[0.7rem]"
                    [class.border-red-500]="feedbackForm.controls.type.touched && feedbackForm.controls.type.invalid"
                >
                    @for (feedbackType of this.feedbackTypes; track feedbackType.value) {
                        <option [value]="feedbackType.value">{{ feedbackType.translationKey | translate }}</option>
                    }
                </select>

                    @if (feedbackForm.controls.type.touched && feedbackForm.controls.type.invalid) {
                        <p class="feedback-error mt-1.5">
                            {{ 'FEEDBACK.TYPE_PLACEHOLDER' | translate }}
                        </p>
                }
            </div>

                <div class="feedback-field mb-[1.15rem]">
                    <label class="mb-2 block">
                    {{ 'FEEDBACK.TOPIC' | translate }}
                    </label>

                <input
                    type="text"
                    formControlName="topic"
                    placeholder="{{ 'FEEDBACK.TOPIC_PLACEHOLDER' | translate }}"
                    class="feedback-control w-full px-3 py-[0.7rem]"
                    [class.border-red-500]="feedbackForm.controls.topic.touched && feedbackForm.controls.topic.invalid"
                />

                    @if (feedbackForm.controls.topic.touched && feedbackForm.controls.topic.invalid) {
                    <p class="feedback-error mt-1.5">
                        {{ 'FEEDBACK.TOPIC_ERROR' | translate }}
                    </p>
                }
            </div>

                <div class="feedback-field mb-[1.15rem]">
                    <label class="mb-2 block">
                    {{ 'FEEDBACK.MESSAGE' | translate }}
                    </label>

                <textarea
                    rows="5"
                    formControlName="message"
                    placeholder="{{ 'FEEDBACK.MESSAGE_PLACEHOLDER' | translate }}"
                    class="feedback-control feedback-message min-h-32 w-full px-3 py-[0.7rem]"
                    [class.border-red-500]="feedbackForm.controls.message.touched && feedbackForm.controls.message.invalid"
                ></textarea>

                    @if (feedbackForm.controls.message.touched && feedbackForm.controls.message.invalid) {
                    <p class="feedback-error mt-1.5">
                        {{ 'FEEDBACK.MESSAGE_ERROR' | translate }}
                    </p>
                }
            </div>

            @if (feedbackForm.controls.type.value === 'general') {

                <div class="feedback-field mb-[1.15rem]">
                    <label class="mb-2 block">
                        {{ 'FEEDBACK.RATING' | translate }}
                    </label>

                    <select
                        formControlName="rating"
                        class="feedback-control w-full px-3 py-[0.7rem]"
                        [class.border-red-500]="feedbackForm.controls.rating.touched && feedbackForm.controls.rating.invalid"
                    >
                        <option [ngValue]="null" disabled>{{ 'FEEDBACK.RATING_PLACEHOLDER' | translate }}</option>
                        @for (rating of this.ratings; track rating) {
                            <option [ngValue]="rating">{{ rating }}</option>
                        }
                    </select>

                    @if (feedbackForm.controls.rating.touched && feedbackForm.controls.rating.invalid) {
                        <p class="feedback-error mt-1.5">
                            {{ 'FEEDBACK.RATING_PLACEHOLDER' | translate }}
                        </p>
                    }
                </div>

            } @else {

                <div class="feedback-field mb-[1.15rem]">
                    <label class="mb-2 block">
                        Urgency
                    </label>

                    <select
                        formControlName="urgency"
                        class="feedback-control w-full px-3 py-[0.7rem]"
                        [class.border-red-500]="feedbackForm.controls.urgency.touched && feedbackForm.controls.urgency.invalid"
                    >
                        <option value="" disabled>{{ 'FEEDBACK.Urgency_PLACEHOLDER' | translate }}</option>
                        @for (urgencyLevel of this.urgencyLevels; track urgencyLevel.value) {
                            <option [value]="urgencyLevel.value">{{ urgencyLevel.translationKey | translate }}</option>
                        }
                    </select>

                    @if (feedbackForm.controls.urgency.touched && feedbackForm.controls.urgency.invalid) {
                        <p class="feedback-error mt-1.5">
                            {{ 'FEEDBACK.Urgency_PLACEHOLDER' | translate }}
                        </p>
                    }
                </div>

            }

                <div class="feedback-actions mt-6 flex justify-end gap-2.5 border-t pt-5">
                <!-- Close FeedbackForm -->
                <button
                    type="button"
                    class="feedback-button feedback-button-secondary px-[1.1rem] py-[0.7rem]"
                    [disabled]="this.submitStatus() === this.submitStatusEnum.SUBMITTING"
                    (click)="uiStore.toggleFeedbackFormVisibility()"
                >
                    {{ 'FEEDBACK.BUTTON_CANCEL' | translate}}
                </button>
                <!-- Submit FeedbackForm -->
                <button
                    type="submit"
                    [disabled]="feedbackForm.invalid || this.submitStatus() === this.submitStatusEnum.SUBMITTING"
                    class="feedback-button feedback-button-primary px-[1.1rem] py-[0.7rem]"
                >
                    {{ 'FEEDBACK.BUTTON_SUBMIT' | translate }}
                </button>

                </div>
            </div>

        </form>

    } @else if (this.submitStatus() === this.submitStatusEnum.SUBMITTED) {

        <!-- SUCCESS VIEW -->
        <div class="feedback-state w-full max-w-md p-8 text-center">

            <div class="feedback-state-icon feedback-state-icon-success mx-auto mb-4 grid h-14 w-14 place-items-center">
                ✓
            </div>

            <h2 class="mb-2">
                Feedback sent!
            </h2>

            <p>
                Thank you for your feedback. We appreciate your input.
            </p>

        </div>

    } @else if (this.submitStatus() === this.submitStatusEnum.ERROR) {

        <!-- ERROR VIEW -->
        <div class="feedback-state w-full max-w-md p-8 text-center">

            <div class="feedback-state-icon feedback-state-icon-error mx-auto mb-4 grid h-14 w-14 place-items-center">
                ✕
            </div>

            <h2 class="mb-2">
                Submission Failed
            </h2>

            <p>
                An error occurred while sending your feedback. Please try again later.
            </p>

        </div>

    }

</div>